import defaultConfig from 'ui-article/axel-publication-content/js/config';

const config = defaultConfig;
config.classNames.DROPDOWN_MENU = 'dropdown-menu';
config.citations.multiRefPopup.enabled = true;
config.collapsible.enabled = true;
config.collapsible.figureKeys = ['table'];
config.collateral.figures.all.linkToViewer.icon = 'ICON_VIEWER';
config.collateral.tooltips = true;
config.figureViewer.focusMode.enabled = true;
config.icons = {
    ...defaultConfig.icons,
    ICON_ACCORDION_ARROW: 'icon-arrow-up',
    ICON_ALL_IN_VIEWER: 'icon-extlink-smooth',
    ICON_PURCHASE_ACCESS: 'icon-lock-open',
    ICON_RETURN: 'icon-return',
    ICON_VIEWER: 'icon-expand',
};
config.stickyHeader.tooltipMenu = true;

export default config;
